import React from "react";
import { Dialog, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

/**
 * Modal shown when route validation fails on save.
 * Lists all validation errors and lets the user either fix issues (close) or save anyway.
 */
const RouteValidationWarningModal = ({
  open,
  onClose,
  errors = [],
  onSaveAnyway,
  loading = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "14px",
          padding: "28px",
        },
      }}
      BackdropProps={{
        style: { backgroundColor: "rgba(0,0,0,0.35)" },
      }}
    >
      {/* Header */}
      <div className="flex justify-between items-start mb-4">
        <div className="flex items-center gap-2">
          <WarningAmberRoundedIcon className="text-amber-500" sx={{ fontSize: 28 }} />
          <h2 className="text-[22px] font-semibold text-gray-800">
            Route configuration issues
          </h2>
        </div>
        <CloseIcon
          className="cursor-pointer text-gray-400"
          onClick={onClose}
        />
      </div>

      {/* Description */}
      <p className="text-gray-600 text-[15px] leading-relaxed mb-3">
        We found the following issues. We recommend fixing them before saving so your route behaves as expected. You can still save anyway if you prefer.
      </p>

      {/* Error list */}
      <ul className="list-disc list-inside text-[15px] text-gray-700 space-y-2 mb-6 max-h-[280px] overflow-y-auto pr-2">
        {errors.map((msg, i) => (
          <li key={i} className="leading-snug">
            {msg}
          </li>
        ))}
      </ul>

      {/* Actions */}
      <div className="flex justify-end gap-3">
        <Button
          variant="outlined"
          disabled={loading}
          onClick={onSaveAnyway}
          sx={{
            textTransform: "none",
            borderRadius: "10px",
            px: 3,
            py: 0.4,
            fontSize: "15px",
            color: "#374151",
            borderColor: "#D1D5DB",
          }}
        >
          Save anyway
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onClose}
          sx={{
            borderRadius: "10px",
            px: 3,
            py: 0.4,
            fontSize: "15px",
          }}
        >
          Fix issues
        </Button>
      </div>
    </Dialog>
  );
};

export default RouteValidationWarningModal;
